import { render, staticRenderFns } from "./CustomerPrivacypolicy.vue?vue&type=template&id=88585dbc&scoped=true"
import script from "./CustomerPrivacypolicy.vue?vue&type=script&lang=js"
export * from "./CustomerPrivacypolicy.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrivacypolicy.vue?vue&type=style&index=0&id=88585dbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88585dbc",
  null
  
)

export default component.exports